import type { Brief } from "../tipos";

/**
 * Sección "Copy de canal": separada de las seis etapas numeradas y sin
 * número — a propósito no usa `EtapaBrief`, porque está fuera del camino
 * crítico: se puede regenerar sin rehacer el concepto, a diferencia de las
 * otras seis.
 */

interface CopyDeCanalProps {
  copy: Brief["copy_de_canal"];
  agente: string;
}

export const CopyDeCanal = ({ copy, agente }: CopyDeCanalProps) => {
  const { instagram_feed, meta_ads } = copy;

  return (
    <section className="rounded-2xl border border-dashed border-[#E2E4EA] bg-[#FAFAFC] p-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h2 className="text-[15px] font-semibold text-brand-black">Copy de canal</h2>
        <span className="shrink-0 text-[12px] text-[rgb(var(--brand-black-rgb)_/_0.55)]">{agente}</span>
      </div>
      <p className="mt-1 text-[12px] text-[rgb(var(--brand-black-rgb)_/_0.5)]">
        fuera del camino crítico: se puede regenerar sin rehacer el concepto.
      </p>

      {instagram_feed && (
        <div className="mt-4">
          <p className="text-[11px] font-medium uppercase tracking-wide text-[rgb(var(--brand-black-rgb)_/_0.4)]">
            Instagram feed
          </p>
          <p className="mt-1 text-[13px] text-brand-black">{instagram_feed.caption}</p>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {instagram_feed.hashtags.map((hashtag) => (
              <span
                key={hashtag}
                className="rounded-full bg-[rgb(var(--brand-primary-rgb)_/_0.08)] py-1 px-2.5 text-[11px] font-medium text-brand-deep"
              >
                {hashtag}
              </span>
            ))}
          </div>
        </div>
      )}

      {meta_ads && (
        <div className="mt-4">
          <p className="text-[11px] font-medium uppercase tracking-wide text-[rgb(var(--brand-black-rgb)_/_0.4)]">
            Meta ads
          </p>
          <p className="mt-1 text-[13px] font-semibold text-brand-black">{meta_ads.titulo}</p>
          <p className="mt-1 text-[13px] text-[rgb(var(--brand-black-rgb)_/_0.7)]">{meta_ads.texto_principal}</p>
          <p className="mt-1 text-[12px] text-[rgb(var(--brand-black-rgb)_/_0.55)]">{meta_ads.descripcion}</p>
        </div>
      )}

      {!instagram_feed && !meta_ads && (
        <p className="mt-4 text-[13px] text-[rgb(var(--brand-black-rgb)_/_0.5)]">
          Todavía no hay copy generado para ningún canal.
        </p>
      )}
    </section>
  );
};

export default CopyDeCanal;
